// Foto ufficiali Legend Team (in /public/images) + segnaposto Unsplash per gli slot ancora senza materiale.
export const IMAGES = {
  heroCar: "/images/subaru-555-drift.jpg",
  cockpit: "/images/ford-sierra-bastos.jpg",
  clubStoriche: "/images/club-storiche-raduno.jpg",
  officina: "/images/officina-legend.jpg",
  negozio: "/images/negozio-sedili.jpg",
  aulaFormazione: "/images/aula-formazione.jpg",
  finnicoLogo: "/images/finnico-corse-logo.png",
  logoWhite: "/images/logo-legend-team-white.png",
  logoBanner: "/images/logo-legend-team-banner.png",
  logoSede: "/images/logo-legend-team-sede.png",
  logoMagazine: "/images/logo-legend-magazine.jpg",
  tesseraMemberGold: "/images/tessera-member-gold.jpg",
  restoDelCarlino: "/images/resto-del-carlino-2020.jpg",
  finnicoAmici: "/images/finnico-corse-amici.jpg",
  contactPhoto: "/images/bmw-merlin-mcg.jpg",
  articoloFinnico: "/images/articolo-finnico-magazine.jpg",
};

// Comunità Papa Giovanni XXIII — pagina donazioni (foto Finnico Corse davanti alla sede)
export const APG23_SITE_URL = "https://www.apg23.org";
export const APG23_DONATE_URL =
  "https://casafamiglia.apg23.org/dona-ora/?gad_source=1&gad_campaignid=23758273582&gclid=Cj0KCQjw2t3VBhD8ARIsAK0F6qxmqh7-7_8wMy3o42poks6RehX0nMjro7B54rUiifVuzTZBLp17losaAhOyEALw_wcB";

export const PRESS_MAGAZINE_URL =
  "https://legendmagazine.it/articolo/storia-del-finnico-nascita-legend-magazine";

export const PRESS_CARLINO_URL =
  "https://www.ilrestodelcarlino.it/cesena/sport/a-savignano-nasce-il-legend-team-cmvgmbf2";

export const MAGAZINE = {
  url: "https://legendmagazine.it",
  name: "Legend Magazine",
  claim: "Il magazine di chi vive il motorsport con passione",
  ticker: [
    "Legend Magazine è ufficialmente una testata giornalistica",
    "Novità bonus per partner e sponsor del Legend Team",
    "Notizie, rally, storiche e Legend Village: leggi su legendmagazine.it",
    "Tessera Member Gold: contenuti esclusivi, sconti, eventi VIP e community",
  ],
};

export const MAPS_EMBED_URL =
  "https://www.google.com/maps?q=legend+team+srl+sant'agata+feltria&hl=it&z=15&output=embed";

export const SOCIAL = {
  instagram: "https://www.instagram.com/legendteam_asd/",
  youtube: "https://www.youtube.com/@LegendTeamASD",
  facebook: "https://www.facebook.com/share/19bdc3Vkim/?mibextid=wwXIfr",
  instagramHandle: "@legendteam_asd",
  villageVideoId: "_ZF--Z39i3o",
  storiaPlaylistId: "PL3nwL_Tib2GCuIOh9o0EE7QCEr9l4TYUF",
  storiaPlaylistUrl: "https://www.youtube.com/playlist?list=PL3nwL_Tib2GCuIOh9o0EE7QCEr9l4TYUF",
};

export const GALLERY = [
  { src: "/images/subaru-wrc-gara.jpg", label: "Subaru Impreza WRC in gara" },
  { src: "/images/paddock-subaru-wrc.jpg", label: "Paddock Legend Team — Subaru WRC e Saxo" },
  { src: "/images/saxo-prova-speciale.jpg", label: "Citroën Saxo Legend Team in prova speciale" },
  { src: "/images/ford-sierra-bastos.jpg", label: "Ford Sierra Cosworth Bastos" },
  { src: "/images/officina-sierra-bastos.jpg", label: "Officina — Sierra Cosworth sul ponte" },
  { src: "/images/lancia-delta-storica.jpg", label: "Lancia Delta — auto storica del Club" },
  { src: "/images/officina-legend.jpg", label: "Officina Legend — reparto corse" },
  { src: "/images/negozio-sedili.jpg", label: "Legend Store — sedili, cinture e scarpe Sparco" },
  { src: "/images/negozio-turbo.jpg", label: "Legend Store — turbo, volanti e componentistica" },
  { src: "/images/negozio-scaffali.jpg", label: "Legend Store — ricambi e accessori racing" },
  { src: "/images/aula-formazione.jpg", label: "Aula corsi piloti e navigatori" },
  { src: "/images/peugeot-106-60-gara.jpg", label: "Peugeot 106 n.60 al via della prova speciale" },
  { src: "/images/saxo-81-sierra-bastos.jpg", label: "Saxo n.81 e Sierra Bastos al parco assistenza" },
  { src: "/images/paddock-peugeot-106.jpg", label: "Paddock — le 106 pronte per la partenza" },
  { src: "/images/paddock-assistenza.jpg", label: "Assistenza Legend Team — Saxo, 106 e BMW" },
  { src: "/images/finnico-corse-piazza.jpg", label: "Finnico Corse in piazza — Delta, Alfa GTV, BMW M3" },
  { src: "/images/paddock-gazebo-legend.jpg", label: "Gazebo Legend Team — parco assistenza in piazza" },
  { src: "/images/officina-bmw-e36.jpg", label: "Officina — BMW E36 Legend Team in preparazione" },
  { src: "/images/sierra-bastos-frontale.jpg", label: "Ford Sierra Cosworth Bastos in prova speciale" },
  { src: "/images/bmw-e46-merlin-tornante.jpg", label: "BMW E46 Merlin Solution — Mulinari/Finnico in tornante" },
];

export const COMPANY = {
  ragioneSociale: "Legend Team Srl Sportiva Dilettantistica",
  indirizzo: "Strada Perticara, 13 • 47866 Sant'Agata Feltria (Rimini)",
  piva: "03858691201",
  email: "info@legendteam.it",
  website: "https://legendteam.it",
  websiteLabel: "legendteam.it",
  whatsapp: "+39 379 1222217",
  whatsappLink: "https://wa.me/393791222217",
  coniCodice: "RN1 001 31",
  entiImg: "/images/enti-affiliazione.png",
};

// Tessere Club (importi definiti anche lato server in backend/tesseramenti.py)
export const TESSERE_NOTE =
  "* I partecipanti potranno entrare dal vivo nelle gare, negli eventi ed è incluso il Legend Village.";

// Documento ufficiale "Davide Bolognesi — Il Finnico e la storia del Legend Team"
export const STORY_PDF = "/docs/davide-bolognesi-storia-legend-team.pdf";

// Cronologia essenziale (fonte: PDF ufficiale, tabella "Cronologia essenziale")
export const TIMELINE = [
  { period: "7 maggio 1972", text: "Davide Bolognesi nasce a Savignano sul Rubicone." },
  { period: "2003", text: "Nasce Finnico Corse Motorsport, la scuderia di Davide \"Il Finnico\" Bolognesi.", accent: true },
  {
    period: "2008",
    text: "Presenze documentate al Trofeo Maremma e al Rally degli Abeti e dell'Abetone su Ford Sierra RS Cosworth 4x4.",
  },
  { period: "2009", text: "Partecipazione documentata alla Ronde Alto Appennino Bolognese su BMW M3." },
  { period: "2010", text: "Partecipazione documentata alla Ronde della Val d'Orcia su Lancia Delta HF Integrale." },
  { period: "2003 – 2012", text: "Presenze di diversi equipaggi sotto l'insegna Finnico Corse." },
  {
    period: "2020",
    text: "Tracce societarie del Legend Team nell'ambito sportivo e nella promozione di eventi, con sede a Sant'Agata Feltria.",
    accent: true,
  },
  {
    period: "Oggi",
    text: "Sviluppo del Legend Team, del progetto Legend Village e della testata Legend Magazine.",
    accent: true,
  },
];

// Vetture documentate negli archivi eWRC citati nel PDF
export const STORY_CARS = [
  { year: "2008", car: "Ford Sierra RS Cosworth 4x4", note: "Trofeo Maremma · Rally degli Abeti e dell'Abetone" },
  { year: "2009", car: "BMW M3", note: "Ronde Alto Appennino Bolognese" },
  { year: "2010", car: "Lancia Delta HF Integrale", note: "Ronde della Val d'Orcia" },
];

// Citazioni autentiche di Davide Bolognesi (dal PDF ufficiale)
export const QUOTES = [
  {
    quote: "Grandi sogni che, con enormi sacrifici, si stanno realizzando. Chi ci segue vedrà.",
    context: "Testo introduttivo al progetto editoriale Legend",
  },
  {
    quote:
      "Tutto questo non sarebbe stato possibile se al mio fianco non avessi avuto la donna stupenda che è mia moglie. Devo veramente tanto a lei.",
    context: "Sui sacrifici condivisi",
  },
  {
    quote: "Seguiteci e ci divertiremo. Grazie Legend Team.",
    context: "Epilogo aperto",
  },
];

// Slot sponsor: logo cliccabile con rimando al sito del partner (griglia 2/4/5 colonne).
export const SPONSORS = [
  { name: "Kemipol", logo: "/images/sponsor/kemipol.png", url: "https://kemipolsrl.it", dark: true },
  { name: "Mulinari Costruzioni Generali", logo: "/images/sponsor/mulinari-costruzioni.jpg", url: "https://mulinaricostruzioni.it" },
  { name: "Merlin Solution", logo: "/images/sponsor/merlin-solution.jpg", url: "https://merlinsolution.eu" },
  { name: "Netso S.p.A.", logo: "/images/sponsor/netso.png", url: "https://netso.it" },
  { name: "Thinnk", logo: "/images/sponsor/thinnk.png", url: "https://thinnk.it" },
  { name: "Pandora Consulting", logo: "/images/sponsor/pandora-consulting.png", url: "https://pandora-consulting.it" },
  { name: "Medius S.r.l. Edilizia", logo: "/images/sponsor/medius.png" },
  { name: "Simoni Racing", logo: "/images/sponsor/simoni-racing.png", url: "https://simoniracing.com", dark: true },
  { name: "Essex Racing Oils & Fuels", logo: "/images/sponsor/essex.jpg", url: "https://essexlubra.com", dark: true },
  { name: "Levii Trentodoc", logo: "/images/sponsor/levii.jpg", url: "https://levii.it", dark: true },
  {
    name: "La Pieda",
    logo: "/images/sponsor/la-pieda.png",
    url: "https://www.facebook.com/Ristorantelapieda/?locale=it_IT",
    caption: "Rist.Pizzeria E45",
  },
];
